module.exports = __webpack_public_path__ + "static/p03_becerro-00cdcb4bb3998ef64d98488dd99c115f.png";